export default "__VITE_ASSET__Cqk_1mLz__"